import React from 'react';
import {motion} from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const {FiCheck,FiX}=FiIcons;

const Comparison=()=> {
  const comparisons=[
    {genx: "Tailored for Gen X learning style",traditional: "One-size-fits-all approach"},
    {genx: "Real-world AI applications",traditional: "Theoretical concepts only"},
    {genx: "Follow-along practical modules",traditional: "Watch-only video lectures"},
    {genx: "15-minute focused lessons",traditional: "3+ hour rambling tutorials"},
    {genx: "Professional instructor with 20+ years experience",traditional: "Young YouTubers with no business experience"},
    {genx: "Immediate workplace application",traditional: "Academic exercises"},
    {genx: "Lifetime access with updates",traditional: "Outdated content quickly"},
    {genx: "Community of professionals your age",traditional: "Mixed age groups with different needs"}
  ];

  const navigateToCourse=()=> {
    window.open('https://swiy.co/hYor','_blank','noopener,noreferrer');
  };

  return (
    <section className="py-16 bg-slate-50 dark:bg-slate-800">
      <div className="max-w-screen-2xl mx-auto px-6 sm:px-8 lg:px-12 xl:px-16">
        <motion.div
          initial={{opacity: 0,y: 30}}
          whileInView={{opacity: 1,y: 0}}
          transition={{duration: 0.6}}
          viewport={{once: true}}
          className="text-center mb-16"
        >
          <h2 className="text-3xl md:text-4xl font-bold text-slate-800 dark:text-white mb-4">
            Why Choose GenXDojo Over Traditional Platforms?
          </h2>
          <p className="text-xl text-slate-600 dark:text-slate-300">
            See the difference our Gen X-focused approach makes
          </p>
        </motion.div>

        <div className="bg-white dark:bg-slate-900 rounded-xl shadow-lg overflow-hidden">
          <div className="grid md:grid-cols-2">
            <div className="bg-green-50 dark:bg-green-900/20 p-6 border-r border-green-200 dark:border-green-800">
              <h3 className="text-xl font-bold text-green-800 dark:text-green-400 mb-6 text-center">
                When You Learn from GenXDojo
              </h3>
            </div>
            <div className="bg-red-50 dark:bg-red-900/20 p-6">
              <h3 className="text-xl font-bold text-red-800 dark:text-red-400 mb-6 text-center">
                When You Learn from Traditional Platforms
              </h3>
            </div>
          </div>

          {comparisons.map((comparison,index)=> (
            <motion.div
              key={index}
              initial={{opacity: 0,x: -30}}
              whileInView={{opacity: 1,x: 0}}
              transition={{duration: 0.5,delay: index * 0.1}}
              viewport={{once: true}}
              className="grid md:grid-cols-2 border-t border-slate-200 dark:border-slate-700"
            >
              <div className="p-6 bg-green-50 dark:bg-green-900/20 border-r border-green-200 dark:border-green-800">
                <div className="flex items-center">
                  <SafeIcon icon={FiCheck} className="w-6 h-6 text-green-600 dark:text-green-400 mr-4 flex-shrink-0" />
                  <span className="text-slate-800 dark:text-slate-200">{comparison.genx}</span>
                </div>
              </div>
              <div className="p-6 bg-red-50 dark:bg-red-900/20">
                <div className="flex items-center">
                  <SafeIcon icon={FiX} className="w-6 h-6 text-red-600 dark:text-red-400 mr-4 flex-shrink-0" />
                  <span className="text-slate-800 dark:text-slate-200">{comparison.traditional}</span>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{opacity: 0,y: 30}}
          whileInView={{opacity: 1,y: 0}}
          transition={{duration: 0.6,delay: 0.5}}
          viewport={{once: true}}
          className="text-center mt-12"
        >
          <p className="text-lg text-slate-700 dark:text-slate-300 mb-6">
            Ready to learn AI the right way for your generation?
          </p>
          <button
            onClick={navigateToCourse}
            className="bg-amber-500 hover:bg-amber-600 text-white px-8 py-4 rounded-lg text-lg font-semibold transition-colors duration-200"
          >
            Join GenXDojo Today
          </button>
        </motion.div>
      </div>
    </section>
  );
};

export default Comparison;